export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1024w.57822ed2.avif";